import React, { Component } from "react";
import EditorLabel from "editor/components/EditorLabel";
import { PropListItem, PropLabel } from "./styles";
import SwitchComponent from "./SwitchComponent/Switch";

class Switch extends Component {
  constructor() {
    super();
    this.state = {
      value: false
    };
  }

  componentDidMount() {
    const { currentValue } = this.props;
    this.setState({ value: currentValue });
  }

  clickHandler = () => {
    const { name, updaterFn } = this.props;
    const { value } = this.state;
    updaterFn({ prop: name, value: !value });
    this.setState({ value: !value });
  };

  render() {
    const { label, locale, tooltip } = this.props;
    const { value } = this.state;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    return (
      <PropListItem>
        <PropLabel>
          <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
        </PropLabel>
        <SwitchComponent value={value} onClick={this.clickHandler} />
      </PropListItem>
    );
  }
}
// updaterFn({ prop: name, value:  })
export default Switch;
